module.exports = __webpack_public_path__ + "img/user.e9e4b792.png";